import Helpers from '@/helpers.js'

export default {
  store: {},
  caseTypeId: 0,
  relationshipData: {},
  lastType: "",
  initialise() {
    this.caseTypeId = 0
    this.relationshipData = {}
    this.lastType = ""
  },
  async loadAll(caseTypeName, relatedData, page) {
    if (caseTypeName !== this.lastType) {
      this.lastType = caseTypeName
      this.store.dispatch("startBucketLoading")
      this.caseTypeName = caseTypeName
      this.relationshipData = relatedData

      const preferences = this.store.state.currentUser.me.preferences
      await this.store.dispatch('getRelatedCases', { caseTypeName: caseTypeName, relatedData: relatedData, page, pageSize: preferences.pageSize })
      const caseType = Helpers.getCaseTypeByCode(this.store.state, caseTypeName)
      this.setupData(caseType, this.store.state.buckets.current.bucket, preferences)
    }
  },
  async setupData(caseType, bucket, preferences) {
    const schemaData = Helpers.prepareBucketSchema(caseType, bucket)
    const bucketHeaderLink = Helpers.getBucketHeaderLink(schemaData)
    const headers = Helpers.formatBucketHeaders(schemaData, bucketHeaderLink)
    const currentCases = Helpers.formatBucketData(schemaData, bucket.cases, preferences, undefined, bucketHeaderLink)

    const schema = schemaData.schema
    this.store.dispatch("setupBucket", { caseType, bucket, headers, currentCases, schema })
  },
  async reload(page, sortField, isDesc) {
    this.store.dispatch("startBucketLoading")

    const preferences = this.store.state.currentUser.me.preferences
    await this.store.dispatch('getRelatedCases', { caseTypeName: this.caseTypeName, relatedData: this.relationshipData, page, pageSize: preferences.pageSize, sortField, sortDirection: isDesc ? "desc" : "asc" })
    const caseType = Helpers.getCaseTypeByCode(this.store.state, this.caseTypeName)
    this.setupData(caseType, this.store.state.buckets.current.bucket, preferences)
  },
  async searchCases(searchParams) { // casetype.name, bucketId, page, pageSize, searchFields, searchTerm
    const preferences = this.store.state.currentUser.me.preferences
    const toCaseType = Helpers.getCaseTypeById(this.store.state, searchParams.relatedData.relationship.toId)

    await this.store.dispatch('getRelatedCases', { caseTypeName: toCaseType.name, relatedData: searchParams.relatedData.relationship, page: searchParams.page, pageSize: preferences.pageSize, sortField: searchParams.sortField, sortDirection: searchParams.sortDirection })
    this.setupData(toCaseType, this.store.state.buckets.current.bucket, preferences)

    this.store.dispatch("stopBucketLoading")
  }  
}
